import { NOTIFICATION_APIS } from "libs/apis/notification.api";
import { useNavigate } from "react-router-dom";

const useNotifications = () => {
  const navigate = useNavigate();

  const getNotifications = async (
    setData: Function,
    queryParams: any = {},
    setFilters?: Function,
    setTotalElements?: Function
  ) => {
    const response = await NOTIFICATION_APIS.getNotification(queryParams);
    const { status = false, data = null } = response || {};
    if (status && data) {
      const {
        content = [],
        pageNumber = 0,
        pageSize = 10,
        totalElements = 0,
      } = data;
      setData(content);
      setFilters((prev) => ({
        ...prev,
        page: pageNumber + 1,
        limit: pageSize,
      }));
      setTotalElements?.(totalElements);
    }
  };

  return {
    getNotifications,
  };
};

export default useNotifications;